import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getMemberNameByUserId } from '../../utils';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Publishers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjust: undefined,
      publishers: [],
      removes: [],
    };
  }

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);

    if (block) {
      if (block.changes) {
        this.setState({
          adjust: block.accept ? !block.accept : block.changes.adjust,
          publishers: block.changes.publishers || [],
          removes: block.changes.removes || [],
        });
      } else {
        this.setState({ adjust: block.accept ? !block.accept : undefined });
      }
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (adjust) {
      let { profile, userInfo, publishers } = this.props;

      if (!userInfo.same) {
        publishers = R.filter(
          (publisher) => publisher.userId === profile.id,
          publishers
        );
      }

      this.props.setBlockChanges({
        id: this.props.block.id,
        options: {
          adjust,
          publishers: [...publishers],
          removes: [],
        },
        checked: true,
      });
    } else {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleChange(e, key, field) {
    const { publishers, removes } = this.state;
    const index = R.findIndex(
      (publisher) => `${publisher.dealUserId}_${publisher.index}` === key
    )(publishers);

    if (index !== -1) {
      publishers[index][field] =
        field === 'publisher_share' ? e.target.value || 0 : e.target.value;
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options: {
        adjust: true,
        publishers: [...publishers],
        removes,
      },
      checked: true,
    });
  }

  handleAddPublisher(dealUserId) {
    const { publishers, removes } = this.state;
    const filtered = R.filter(
      (publisher) => publisher.dealUserId === dealUserId,
      publishers
    );
    const index = R.findIndex(
      (publisher) =>
        dealUserId === publisher.dealUserId &&
        filtered.length - 1 === publisher.index
    )(publishers);

    this.props.setBlockChanges({
      id: this.props.block.id,
      checked: true,
      options: {
        adjust: true,
        publishers: R.insert(
          index + 1,
          {
            ...publishers[index],
            id: null,
            index: filtered.length,
            publisher_name: '',
            publisher_share: 0,
            society: '',
          },
          publishers
        ),
        removes,
      },
    });
  }

  handleRemovePublisher(key) {
    const { publishers, removes } = this.state;
    const index = R.findIndex(
      (publisher) => `${publisher.dealUserId}_${publisher.index}` === key
    )(publishers);

    if (index !== -1) {
      if (publishers[index].id) {
        const removed = R.find(R.propEq('id', publishers[index].id))(
          this.props.publishers
        );
        if (removed) {
          removes.push({ ...removed });
        }
      }
      publishers.splice(index, 1);
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      checked: true,
      options: {
        adjust: true,
        publishers: [...publishers],
        removes: [...removes],
      },
    });
  }

  renderOriginal() {
    return this.renderPublishers();
  }

  renderAdjust() {
    return this.renderPublishers(true);
  }

  renderPublishers(withState = false) {
    const { dealUsers, members, userInfo, profile } = this.props;

    if (dealUsers && dealUsers.length) {
      return (
        <div className="ownership-splits">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Publisher</th>
                <th>Society</th>
                <th>Publisher Share%</th>
              </tr>
            </thead>
            <tbody>
              {dealUsers.map((dealUser, i) => {
                if (dealUser.type !== 'member') {
                  return null;
                }

                if (
                  withState &&
                  (userInfo.same || dealUser.user === profile.id)
                ) {
                  const publishers = R.filter(
                    (publisher) => publisher.userId === dealUser.user,
                    this.state.publishers
                  );

                  if (publishers && publishers.length) {
                    return publishers.map((publisher) => {
                      const key = `${publisher.dealUserId}_${publisher.index}`;
                      return (
                        <tr key={key}>
                          <td>
                            {publisher.index === 0
                              ? getMemberNameByUserId(publisher.userId, members)
                              : ''}
                          </td>
                          <td>
                            <input
                              type="text"
                              value={publisher.publisher_name}
                              onChange={(e) =>
                                this.handleChange(e, key, 'publisher_name')
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={publisher.society}
                              onChange={(e) =>
                                this.handleChange(e, key, 'society')
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={publisher.publisher_share}
                              onChange={(e) =>
                                this.handleChange(e, key, 'publisher_share')
                              }
                            />{' '}
                            %
                          </td>
                          <td>
                            {publisher.index === 0 ? (
                              <a
                                onClick={() =>
                                  this.handleAddPublisher(publisher.dealUserId)
                                }
                              >
                                + Another
                              </a>
                            ) : (
                              <a
                                onClick={() => this.handleRemovePublisher(key)}
                              >
                                x Remove
                              </a>
                            )}
                          </td>
                        </tr>
                      );
                    });
                  }
                  return null;
                } else {
                  if (dealUser.publishers && dealUser.publishers.length) {
                    return dealUser.publishers.map((publisher, j) => (
                      <tr key={`${i}${j}`}>
                        <td>
                          {j === 0
                            ? getMemberNameByUserId(dealUser.user, members)
                            : ''}
                        </td>
                        <td>{publisher.publisher_name}</td>
                        <td>{publisher.society}</td>
                        <td>
                          {publisher.publisher_share
                            ? publisher.publisher_share + '%'
                            : ''}
                        </td>
                      </tr>
                    ));
                  } else {
                    return (
                      <tr key={i}>
                        <td>{getMemberNameByUserId(dealUser.user, members)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </table>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    let changing = '';
    let removing = '';
    let content = '';
    const removes =
      (changeRequest.changes && changeRequest.changes.removes) || [];

    if (changeRequest.changes && changeRequest.changes.publishers) {
      changeRequest.changes.publishers.forEach((publisher) => {
        if (
          publisher.publisher_name ||
          publisher.society ||
          publisher.publisher_share
        ) {
          if (changing === '') {
            changing = ' changing to: ';
          } else {
            changing += ', and ';
          }
          changing += `<span class="text-red">${publisher.publisher_name}, ${publisher.society}, ${publisher.publisher_share}%</span>`;
        } else if (publisher.id) {
          const index2 = R.findIndex(R.propEq('id', publisher.id))(
            this.props.publishers
          );
          const index3 = R.findIndex(R.propEq('id', publisher.id))(removes);
          if (index2 !== -1 && index3 === -1) {
            removes.push({ ...this.props.publishers[index2] });
          }
        }
      });
    }

    removes.forEach((publisher) => {
      if (
        publisher.publisher_name ||
        publisher.society ||
        publisher.publisher_share
      ) {
        if (removing === '') {
          removing = ' removing: ';
        } else {
          removing += ', and ';
        }
        removing += `<span class="text-red">${publisher.publisher_name}, ${publisher.society}, ${publisher.publisher_share}%</span>`;
      }
    });

    content = changing;
    if (removing !== '') {
      if (changing === '') {
        content = removing;
      } else {
        content += ', and ' + removing;
      }
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <div className="questions">
                <p className="question">
                  Do you want to add any publishing information about the
                  work(s)?
                </p>
                <FormGroup className="answer">
                  <Row>
                    <Col sm={6}>
                      <Radio
                        name="overview-adjust"
                        checked={this.state.adjust === false}
                        onChange={() => this.handleAdjust(false)}
                      >
                        {this.props.userInfo.same
                          ? `Keep this publisher information:`
                          : `Accept ${this.props.userInfo.name} 's proposed publisher information:`}
                      </Radio>
                    </Col>
                    <Col sm={6}>
                      <Radio
                        name="overview-adjust"
                        checked={this.state.adjust === true}
                        onChange={() => this.handleAdjust(true)}
                      >
                        {this.props.userInfo.same
                          ? `Change the publisher information:`
                          : `Suggest an alternative:`}
                      </Radio>
                    </Col>
                  </Row>
                </FormGroup>
                {this.state.adjust === true
                  ? this.renderAdjust()
                  : this.renderOriginal()}
                {this.props.renderAccepts()}
                {this.renderChangeRequests()}
              </div>
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Publishing related income such as synchronization fees, public
                  performance royalties, mechanical royalties and others are
                  often paid out according to each publisher's share. Taking the
                  time now to list all of the publishers associated with your
                  work(s) and their shares can help you to avoid serious legal
                  and financial issues in the future.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a publisher?</p>
                <p className="small">
                  A publisher is a company that receives and administers your
                  publishing income. They retain a percentage of your publishing
                  income and can also have an ownership interest in your musical
                  composition copyrights. If you are self-published, your
                  publisher could be your name or company as registered with
                  your public performance society (ASCAP, BMI, SESAC, SOCAN
                  etc).
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is the publisher's share?</p>
                <p className="small">
                  The publisher's share is the percentage of publishing related
                  income that a publisher is entitled to.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a society?</p>
                <p className="small">
                  A public performance society collects royalties on your behalf
                  each time your music is publicly performed (i.e. performed
                  live on stage, played on the radio, played as background music
                  in a restaurant, etc.). ASCAP, BMI, SESAC, SOCAN are examples
                  of public performance rights societies that collect these
                  royalties.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Publishers.jsx